<app-loader *ngIf="isLoading"></app-loader>
<div
  *ngIf="cs.isBrowser && !isLoading && shortendURL"
  class="modal-content modal-theme2 share-modal"
  [ngClass]="{ 'reel-modal': this.data?.modalInfo }"
>
  <div class="modal-header">
    <h4 *ngIf="modalInfo.sharingResource" class="modal-title">
      <ng-container [ngSwitch]="modalInfo.sharingResource">
        <ng-container *ngSwitchCase="'postShare'">
          Share {{ fullName }}'s Post
        </ng-container>
        <ng-container *ngSwitchCase="consts.ADVERTISEMENT_SHARE">
          Share {{ fullName }}'s Advertisement
        </ng-container>
        <ng-container *ngSwitchCase="NEW_POST_CONST.LIVE_STREAM">
          Share {{ fullName }}'s Livestream
        </ng-container>
        <ng-container *ngSwitchCase="consts.WELCOME_VIDEO_SHARE">
          Share {{ fullName }}'s Welcome Message
        </ng-container>
        <ng-container *ngSwitchCase="consts.MERCHANDISE_STORE">
          Share {{ fullName }}'s {{ FeedType[feedType] }}
        </ng-container>
        <ng-container *ngSwitchCase="consts.PORTFOLIO_SHARE">
          Share {{ fullName }}'s {{ modalInfo.portfolioMsg }}
        </ng-container>
        <ng-container *ngSwitchCase="'pageShare'">
          <ng-container *ngIf="modalInfo.isMyProfile">
            Check out My Profile
          </ng-container>
          <ng-container *ngIf="!modalInfo.isMyProfile">
            Check out {{ modalInfo.firstName }}
            {{ modalInfo.lastName }}
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'forumShare'">
          Share {{ fullName }}'s {{ chatRoomLabel }}
        </ng-container>
        <ng-container *ngSwitchCase="consts.REFERRAL_SHARE">
          {{ consts.REFERRAL_HEADER_TITLE }}
        </ng-container>
        <ng-container *ngSwitchCase="'eventTicket'">
          Share {{ fullName }}'s Event
        </ng-container>
        <ng-container *ngSwitchDefault>
          Share {{ fullName }}'s Post
        </ng-container>
      </ng-container>
    </h4>
    <div *ngIf="data?.modalInfo" (click)="closeDialog()">
      <em class="icon-cross"></em>
    </div>
  </div>
  <div class="modal-body modal-share">
    <div class="modal-share-input">
      <input [value]="shortendURL" type="text" readonly />
      <em
        (click)="copyReferralLink(modalInfo.sharingResource)"
        class="icon-copy hand-cursor"
      ></em>
    </div>
    <div class="modal-share-links">
      <div class="modal-share-social-row">
        <share-buttons
          [theme]="'circles-light'"
          [include]="['facebook']"
          [size]="-3"
          [url]="
            modalInfo.sharingResource !== 'referralShare'
              ? '\n' + shortendURL
              : '\n' + shortendURL
          "
          [autoSetMeta]="true"
          style="white-space: pre-line"
          [title]="shareTitleEmail"
          [description]="shareDescription"
          (click)="setCountOfSharePost()"
        ></share-buttons>
        <div #twitterShareWrap class="twitter-share-capture">
          <share-buttons
            [theme]="'circles-light'"
            [include]="['twitter']"
            [size]="-3"
            [url]="
              modalInfo.sharingResource !== 'referralShare'
                ? '\n' + shortendURL
                : '\n' + shortendURL
            "
            [autoSetMeta]="true"
            style="white-space: pre-line"
            [title]="shareTitleEmail"
            [description]="shareDescription"
            (click)="setCountOfSharePost()"
          ></share-buttons>
        </div>
      </div>
      <share-buttons
        [theme]="'circles-light'"
        [include]="['email']"
        [size]="-3"
        [url]="
          modalInfo.sharingResource !== 'referralShare' || modalInfo.userName
            ? '\n' + shortendURL
            : ''
        "
        [autoSetMeta]="true"
        style="white-space: pre-line"
        [title]="shareTitleEmail"
        [description]="shareDescriptionEmail"
        (click)="setCountOfSharePost()"
      ></share-buttons>
      <share-buttons
        [theme]="'circles-light'"
        [include]="['sms']"
        [size]="-3"
        [url]="
          modalInfo.sharingResource !== 'referralShare' || modalInfo.userName
            ? '\n' + shortendURL
            : ''
        "
        [autoSetMeta]="true"
        style="white-space: pre-line"
        [title]="shareTitleEmail"
        [description]="shareDescriptionEmail"
        (click)="setCountOfSharePost()"
      ></share-buttons>
    </div>
  </div>
  <div
    class="modal-footer"
    [ngClass]="{
      'cancel-btn': modalInfo.sharingResource === consts.REFERRAL_SHARE
    }"
  >
    <button
      *ngIf="!this.data?.modalInfo"
      (click)="closeDialog()"
      class="btn btn-default text-center"
    >
      Cancel
    </button>
    <button
      *ngIf="modalInfo.sharingResource !== consts.REFERRAL_SHARE"
      (click)="navigateToReferral()"
      class="btn btn-primary"
    >
      {{
        cs.isWhiteLabelWeb
          ? consts.LEADERBOARD_BUTTON_WHITELABEL
          : consts.RECRUITMENT_LEADERBOARD_BUTTON
      }}
    </button>
  </div>
</div>
